export class EventEmitter {
    constructor() {
    }

    protected static handlers: Object = null
    protected static eventsQueue: {
        name: string,
        data: any,
        namespace: string
    }[] = []

    public static handlerPrefix: string = 'on'

    public fire(eventName: string, data?: any, namespace?: string, fireImmediately?: boolean) {
        if (!namespace) {
            namespace = "global"
        }

        // if there are no events in the queue we should treat this as a normal event
        // ignoring the value of fireImmediately, otherwise if other events are fired while
        // processing this event they will not wait in a queue until this event is completely processed
        if (fireImmediately && EventEmitter.eventsQueue.length > 0) {
            this.processEvent(eventName, data, namespace)
        } else {
            EventEmitter.eventsQueue.push({
                name: eventName,
                data: data,
                namespace: namespace
            })

            // when the queue contains more than 1 event, this means that there are
            // currently other events that are being processed so we should wait for them
            if (EventEmitter.eventsQueue.length > 1) {
                return
            }

            // at this point we know that there are no events currently being processed,
            // so we can process this event immediately, and then continue to process events
            // that might have been added to the queue while this event was being processed
            do {
                const event = EventEmitter.eventsQueue[0]
                this.processEvent(event.name, event.data, event.namespace)
                EventEmitter.eventsQueue.shift()
            } while (EventEmitter.eventsQueue.length > 0)
        }
    }

    private processEvent(eventName: string, data: any, namespace: string) {
        let idx, eventObjects

        try {
            eventObjects = EventEmitter.handlers[namespace]
        } catch (e) {
            return // No handlers yet.
        }

        try {
            idx = eventObjects.findIndex(x => x.name === eventName.substr(EventEmitter.handlerPrefix.length).split("_")[0])
        } catch (e) {
            idx = -1
        }

        if (idx > -1) {
            eventObjects[idx].handlers.forEach(handlerObject => {
                handlerObject.handler.call(handlerObject.instance, data)
            })
        }
    }
}
